const { DTO } = require("@cloudbreakus/network-utilities")

class CallSegmentsUpdateModel extends DTO {
  optionalFields = ["notes", "languageId", "interpreterName"]
  acceptNulls = false
}

module.exports = CallSegmentsUpdateModel
